import { render } from "./UserAccountForm.vue?vue&type=template&id=5803aee2&scoped=true"
import script from "./UserAccountForm.vue?vue&type=script&lang=js"
export * from "./UserAccountForm.vue?vue&type=script&lang=js"

import "./UserAccountForm.vue?vue&type=style&index=0&id=5803aee2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5803aee2"

export default script